const { Swiper } = require('swiper');
import { EffectFade, Navigation, Thumbs } from 'swiper/modules';

const historySections = document.querySelectorAll('section.history');

if (historySections.length) {
    Swiper.use([Navigation, Thumbs, EffectFade]);
    historySections.forEach(element => {
        const sliderElement = element.querySelector('.js-history-slider');
        const prevArrow = sliderElement.querySelector('.-prev');
        const nextArrow = sliderElement.querySelector('.-next');

        const thumbsSliderElement = element.querySelector(
            '.js-history-navigation-slider'
        );
        let thumbsSwiper;

        if (thumbsSliderElement) {
            thumbsSwiper = new Swiper(thumbsSliderElement, {
                freeMode: true,
                watchSlidesProgress: true,
                slidesPerView: 5,
                spaceBetween: 3,
                direction: 'vertical',
            });
        }

        const swiper = new Swiper(sliderElement, {
            navigation: {
                prevEl: prevArrow,
                nextEl: nextArrow,
                disabledClass: '-disabled',
            },
            thumbs: {
                swiper: thumbsSwiper,
                slideThumbActiveClass: '-active',
            },
            effect: 'fade',
            slideActiveClass: '-active',
        });

        if (prevArrow && nextArrow) {
            swiper.on('slideChange', e => {
                const { realIndex, slides } = e;
                const backIndex = realIndex - 1 < 0 ? 0 : realIndex - 1;
                const nextIndex =
                    realIndex === slides.length - 1 ? realIndex : realIndex + 1;

                const backYear = slides[backIndex].getAttribute('data-year');
                const nextYear = slides[nextIndex].getAttribute('data-year');

                prevArrow.querySelector('span').textContent = backYear;
                nextArrow.querySelector('span').textContent = nextYear;
            });
        }
    });
}
